import { fetchSections } from 'lib/models/sections';
import { useCallback, useEffect, useState } from 'react';

function useUserSection() {
	const [loading, setLoading] = useState(true);
	const [sections, setSections] = useState<any | null>(null);

	const refetch = useCallback(async () => {
		setLoading(true);

		try {
			const res = await fetchSections();

			setSections(res);
		} catch (error) {
			console.error(error);
		}

		setLoading(false);
	}, []);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, sections, refetch };
}

export default useUserSection;
